import { DesktopWindow } from "desktopWindow/components/DesktopWindow";
import { useWindowTile } from "desktopWindow/context/WindowTilesContext";
import { NotesViewer } from "./NotesViewer";
import { GameTutorialElements } from "../../../gameTutorial/types";

interface Props {
	// Window tile id
	tileId: string;
}
export const NoteWindow = ({ tileId }: Props) => {
	const { size } = useWindowTile(tileId);
	return (
		<DesktopWindow id={tileId} className={GameTutorialElements.NOTE_BORWSER_WINDOW}>
			<NotesViewer size={size} />
		</DesktopWindow>
	);
};
